<div class="container">
    <div class="row">
        <div class="col-md-4">
            <div>
                <label>Struttura</label>
                <select
                    class="form-control"
                    id="tipo_struttura"
                    [(ngModel)]="tipo_struttura_corrente_id"
                >
                    <option
                        *ngFor="let t of tipi_struttura"
                        [value]="t.id"
                    >{{t.value}}</option>
                </select><br>
            </div>
            <div>
                <label>Area vasta</label>
                <select
                    class="form-control"
                    id="aree_vaste"
                    [(ngModel)]="area_vasta_corrente_id"
                >
                    <option
                        *ngFor="let a of aree_vaste"
                        [value]="a.id"
                    >{{a.nome}}</option>
                </select><br>
            </div>
            <div>
                <label>Distretto</label>
                <select
                    class="form-control"
                    id="distretto"
                    [(ngModel)]="distretto_corrente_id"
                >
                    <option
                        *ngFor="let d of distretti_filtered"
                        [value]="d.id"
                    >{{d.nome}}</option>
                </select><br>
            </div>
        </div>
        <div class="col-md-1"></div>
        <nb-list class="col-6 container">
            <nb-list-item
                *ngFor="let s of strutture_filtered"
                class="row"
                (click)="openDettaglioStruttura(s)"
            >
                <div class="col-2">
                    <div *ngIf="s.tipologia_struttura == 1">
                        <img src="/assets/images/strutture/hospital-symbol-solid.svg">
                    </div>
                    <div *ngIf="s.tipologia_struttura == 2">
                        <img src="/assets/images/strutture/clinic-medical-solid.svg">
                    </div>
                </div>
                <div class="col-6">
                    <h6>{{s.nome.it}}</h6><small>{{s.indirizzo}}</small>
                </div>
                <div class="col-3"><i><small>{{getNomeDistretto(s.distretto)}}</small></i></div>
            </nb-list-item>
        </nb-list>
    </div>
</div>
